import React, { useEffect, useState } from "react"
import { SelectBox, TextArea, TextBox} from 'devextreme-react';
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/selectors";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function ItvForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode)


useEffect(()=>{
    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function getNameFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.name
    }
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>   
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                            <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                                    
                </div>
                <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                    <InputWrapper classes={classes} label={"DNI"}>
                        <TextBox key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                                  
                </div>
                <InputWrapper classes={classes} label={"Accesorio instalado por"}>
                    <SelectBox value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value); onChange("accesoryInstaller", getNameFromCode(e.value))}} valueExpr="code" displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Motivo ITV desfavorable"}>
                    <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
                </InputWrapper>
        </div>
    )
}

export { ItvForm }